module.exports = __webpack_public_path__ + "img/08.acd959e5.png";